export const iconFontAwesomeChildhoodAppleWhole = (
	<i className="fa-solid fa-apple-whole"></i>
);
